import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import fetchTaskUserImage from 'actions/ProfilePicture';
import {
  COMPLETED,
  ONGOING,
  PAUSED,
  ACT1,
  ACT7,
  ACT9,
  ACT10,
  ACT11,
  ACT12,
  ACT13,
  ACT16,
  ACT18,
  ACT20,
  ACT28,
  ACT30,
  ACT31,
  ACT32
} from 'constants/index';
import { SecondsTohoursMinutes, GetValuesFromDate, ParseISOString, PadString } from 'utils/index';
import { Box, Typography, Checkbox } from '@mui/material';
import * as fieldListStyle from '../../fields/fieldtab/FieldListStyle';

class TaskListItem extends Component {
  /**
   * To pass object the checked status of the item
   * @param {object} e div element object
   */
  checkBoxChange = e => {
    const { handleCheckbox } = this.props;
    handleCheckbox(e);
  };

  /**
   * get the time formate to display
   *
   */
  getDurationFormate = () => {
    const { TaskDetails } = this.props;
    if (TaskDetails.netDuration) {
      const hrsMin = SecondsTohoursMinutes(TaskDetails.netDuration);
      return `${PadString(hrsMin.hours)} hrs ${PadString(hrsMin.minutes)} min`;
    }
    return null;
  };

  /**
   * get the end-time formate to display
   *
   */
  getEndTime = () => {
    const { TaskDetails } = this.props;
    if (TaskDetails.endTime) {
      const dateObj = new Date(ParseISOString(TaskDetails.endTime));
      const day = `${dateObj.getDate()}`.padStart(2, '0');
      const month = `${dateObj.getMonth() + 1}`.padStart(2, '0');
      const year = `${dateObj.getFullYear()}`.slice(-2);
      return `${day}.${month}.${year}`;
    }
    return null;
  };

  getAmount = () => {
    const { TaskDetails } = this.props;
    if (TaskDetails.taskActivity) {
      const amountUnit = TaskDetails.taskActivity;
      switch (amountUnit.activityId) {
        case ACT9:
        case ACT10:
        case ACT28:
          return {
            amount: amountUnit.cutAmount ? amountUnit.cutAmount : null,
            unit: amountUnit.cutUnit
          };
        case ACT11:
        case ACT12:
        case ACT16:
        case ACT18:
          return {
            amount: amountUnit.cutAmount ? amountUnit.cutAmount : null,
            unit: <FormattedMessage id="TASK_DYNAMIC_HARVEST_UNIT" />
          };
        case ACT20:
          return {
            amount: amountUnit.comboFertiAmount ? amountUnit.comboFertiAmount : null,
            unit: amountUnit.comboFertiUnit
          };
        case ACT13:
          return {
            amount: amountUnit.totalHarvest ? amountUnit.totalHarvest : null,
            unit: 'kg/daa'
          };
        case ACT1:
        case ACT7:
        case ACT30:
        case ACT31:
        case ACT32:
          return { amount: amountUnit.amount ? amountUnit.amount : null, unit: amountUnit.unit };
        default:
          return null;
      }
    }
    return null;
  };

  getCropLabel = () => {
    const { TaskDetails } = this.props;
    const { activityId, taskActivity } = TaskDetails;
    if (!activityId || !taskActivity) return '';
    if ([ACT7, ACT31, ACT32].includes(activityId)) {
      return taskActivity.subType && taskActivity.subType.trim() !== ''
        ? taskActivity.subType
        : <FormattedMessage id="NOT_DEFINED" />;
    }
    if (activityId === ACT30) {
      return taskActivity.manureStorageName && taskActivity.manureStorageName.trim() !== ''
        ? taskActivity.manureStorageName
        : <FormattedMessage id="NOT_DEFINED" />;
    }
    if ([ACT9, ACT10, ACT28, ACT11, ACT12, ACT16].includes(activityId)) {
      return 'Avling';
    }
    return ''; // empty for other activity types
  };


  render() {
    const { TaskDetails, checked, isLoading, hasPermission, intl, handleOpenModalWindow, handleCheckbox } = this.props;
    const status = TaskDetails.status ? TaskDetails.status.toUpperCase() : null;
    const amountAndUnit = this.getAmount();
    const isDisabled = isLoading && 'disable';
    let seasonName = null;
    if (TaskDetails.seasonId) {
      if (TaskDetails.seasonId === 1) {
        seasonName = intl.formatMessage({ id: 'CHOOSE_FERTILIZATION' });
      } else if (TaskDetails.seasonId === 2) {
        seasonName = intl.formatMessage({ id: 'CHOOSE_FIRST_HARVEST' });
      } else if (TaskDetails.seasonId === 3) {
        seasonName = intl.formatMessage({ id: 'CHOOSE_SECOND_HARVEST' });
      } else if (TaskDetails.seasonId === 4) {
        seasonName = intl.formatMessage({ id: 'CHOOSE_THIRD_HARVEST' });
      } else {
        seasonName = null;
      }
    }

    console.log("TaskDetails: ", TaskDetails.activityId);

    let cut = null;
    if (TaskDetails.taskActivity.cut) {
      if (TaskDetails.taskActivity.cut === 1) {
        cut = "1. slått";
      } else if (TaskDetails.taskActivity.cut === 2) {
        cut = "2. slått";
      } else if (TaskDetails.taskActivity.cut === 3) {
        cut = "3. slått";
      } else if (TaskDetails.taskActivity.cut === 4) {
        cut = "4. slått";
      } else {
        cut = null;
      }
    }

    return (
      <li
        className={'task-list-item show-checkbox full-width'}
        style={{
          borderBottom: '1px solid #BEC8C9',
          padding: '0px',
          margin: '0px',
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          width: '100%',
          padding: '12px 0',
        }}
        key={TaskDetails.id}
      >
        <Checkbox
          checked={checked} // coming from parent
          onChange={(e) => handleCheckbox(e, TaskDetails.id)}
          sx={{
            color: '#000',
            '&.Mui-checked': { color: '#00696D' },
          }}
        />
        {/* This Box will now hold all the column content for a single row */}
        <Box
          className="task-details"
          onClick={() => handleOpenModalWindow(TaskDetails.id)}
          style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            flex: '1',
            minWidth: 0,
          }}
        >
          {/* Column 1: Registering / Activity Name */}
          <Box style={{ flex: 2, minWidth: 0 }}> {/* Matches header flex: 2 */}
            <Typography style={fieldListStyle.listRowSubItem}>
              {seasonName !== null ? seasonName : cut}
            </Typography>
            <Typography style={fieldListStyle.listRowItem}>
              {TaskDetails.activityId ? TaskDetails.activityName : <FormattedMessage id="NOT_DEFINED" />}
            </Typography>
          </Box>

          {/* Column 2: Date */}
          <Box style={{ flex: 1, minWidth: 0 }}>
            <Typography style={fieldListStyle.listRowItem}>
              {TaskDetails.endTime ? this.getEndTime() : '--'}
            </Typography>
          </Box>

          {/* Column 3: Skiftenavn / Field Name */}
          <Box style={{ flex: 1, minWidth: 0 }}>
            <Typography style={fieldListStyle.listRowSubItem}>
              {TaskDetails.fieldArea ? TaskDetails.fieldArea : ''}
            </Typography>
            <Typography style={fieldListStyle.listRowItem}>
              {TaskDetails.fieldId ? TaskDetails.fieldName : <FormattedMessage id="NOT_DEFINED" />}
            </Typography>
          </Box>

          {/* Column 4: Amount */}
          <Box style={{ flex: 1, minWidth: 0 }}>
            <Typography style={fieldListStyle.listRowSubItem}>
              {this.getCropLabel() || '\u00A0'}
            </Typography>
            <Typography style={fieldListStyle.listRowItem}>
              {amountAndUnit && amountAndUnit.amount ? (
                <span
                  title={`${amountAndUnit.amount} ${amountAndUnit.unit}`}
                >
                  {amountAndUnit.amount} {amountAndUnit.unit}
                </span>
              ) : (
                '-'
              )}
            </Typography>
          </Box>
        </Box>
      </li>
    );
  }
}

const mapStateToProps = state => ({
  /*AWSLoginDetails: state.AWSLogin.data,*/
  profilePictures: state.profileImage.userImage
});

const mapDispatchToProps = dispatch => ({
  getTaskUserImage: (AWSLogin, type, id, userType) => dispatch(fetchTaskUserImage(AWSLogin, type, id, userType))
});

export default connect(mapStateToProps, mapDispatchToProps)(TaskListItem);